import { makeStyles } from "@material-ui/core/styles"

export default makeStyles(() => ({
  // default variant
  contentRoot: {
    backgroundColor: "#1c313a",
    color: "#f1f1f1",
    "& span": {
      color: "#d3a03e"
    }
  },
  variantSuccess: {
    backgroundColor: "#a2c79c",
    color: "#0e2800",
    "& span": {
      color: "inherit"
    }
  },
  variantError: {
    backgroundColor: "#FFC9CA",
    color: "#8A272C",
    "& span": {
      color: "inherit"
    }
  },
  variantInfo: {
    backgroundColor: "#1c313a",
    color: "#f1f1f1",
    "& .MuiSvgIcon-root": {
      color: "#d3a03e"
    },
    "& span": {
      color: "#d3a03e"
    }
  },
  variantWarning: {
    backgroundColor: "#FFCC80",
    color: "#513d00",
    "& span": {
      color: "inherit"
    }
  }
}))
